

import React, { useState } from "react";

function FormatDecimal(props)
{

    
    var n = props.value

    n = parseFloat(n).toFixed(2);

    if(isNaN(n)) n = "0";

    var str = "" + n;
    str = str.replace('.', ',')
    
    

    return <React.Fragment>
        {str}
    </React.Fragment>
}

export default FormatDecimal;